import shipmentEmergencyService from './shipment-emergency-service';

export default shipmentEmergencyService;
